<template>
  <div ref="parallax" class="parallax" style="positon: relative">
    <div class="scroller" ref="scroller"><slot></slot></div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Parallax',
  props: ['height', 'centered'],
  computed: {
      scroller () { return this.$refs.scroller },
      parallax () { return this.$refs.parallax }
  },
  mounted () {
    this.parallax.style.maxHeight = `${this.height}px`
    if (this.centered) {
        this.$slots.default[0].elm.style.transform = `translate(0, ${this.$slots.default[0].elm.height / 4}px)`
    }
    document.addEventListener('scroll', () => {
        this.scroller.style.transform = `translate(0, ${window.scrollY / 4}px)`
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../index.scss';
.parallax {
  overflow: hidden;
  height: 100%;
  .scroller {
    height: 100%;
    /deep/ img {
      width: 100%;
    }
  }
}
</style>